/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function getCurrentURL() {
  return window.location.href
}
var url = getCurrentURL();


function loginClick(x) {
  if (url.includes("/fr/")) {
    window.location.href = '/fr/account/login?return_url=/fr' + x
  } else {
    window.location.href = '/account/login?return_url=' + x
  };
};


function customerLoggedIn(x, y, z) {
  if (x) {
    var homePageButtons = document.getElementById("images-text-buttons")
    if (homePageButtons) {
      homePageButtons.innerHTML = `<span onclick="location.href='${z}'" class="button button--primary">${y}</span>`
    };
    var homePageWelcome = document.getElementById("images-text-heading")
    if (homePageWelcome) {
      homePageWelcome.innerHTML = `${homePageWelcome.innerText}, ${x}`
    };
  };
}

//sets inital salon price
var salonInsert = document.getElementById("salonPrice")
var salonRegularPrice = document.getElementById("salonRegularPrice")
var highlightDiv = document.getElementById("highlight")
var metaData = localStorage.getItem("metaData")
var metaDealData = localStorage.getItem("metaDealData")
var firstVariant = localStorage.getItem("firstVariant")
metaData = JSON.parse(metaData)
metaDealData = JSON.parse(metaDealData)
if (metaData) {
  var salonPrice = (parseFloat(metaData[firstVariant]))
  if (isNaN(salonPrice)) {
    salonPrice = '$  -'
  } else {
    salonPrice = '$' + salonPrice.toFixed(2)
  }
  var salonDealPrice = (parseFloat(metaDealData[firstVariant]))
  if (isNaN(salonDealPrice)) {
    if (salonInsert) {
      salonInsert.innerHTML = salonPrice
      document.getElementById("salonPriceLoader").style.display = 'none'
    };
  } else {
    if (salonInsert) {
      salonInsert.innerHTML = '$' + salonDealPrice.toFixed(2)
      document.getElementById("salonPriceLoader").style.display = 'none'
    };
    if (highlightDiv) {
      highlightDiv.classList.add("price--highlight");
    };
    if (salonRegularPrice) {
      salonRegularPrice.innerHTML = salonPrice
    };
  };
}

//sets initial pack size
var uomDiv = document.getElementById("uomDiv")
var packSizeDiv = document.getElementById("packSizeDiv") //goes beside uom
var caseQtyDiv = document.getElementById("caseQtyDiv")
var caseQtySpan = document.getElementById("caseQtySpan")
var boxQtyDiv = document.getElementById("boxQtyDiv")
var boxQtySpan = document.getElementById("boxQtySpan")
var uom = localStorage.getItem("uom")
var caseSize = localStorage.getItem("caseSize")
var boxSize = localStorage.getItem("boxSize")
uom = JSON.parse(uom)
caseSize = JSON.parse(caseSize)
boxSize = JSON.parse(boxSize)

if (uom) {
  var uomInsert = uom[firstVariant]
  if (uomInsert === null) {
    if (uomDiv) {
      uomDiv.innerHTML = ''
    };
  } else {
    if (uomDiv) {
      uomDiv.innerHTML = '  / ' + uomInsert
    }
  };
  if (caseSize) {
    var caseSizeInsert = parseInt(caseSize[firstVariant])
  }
  if (boxSizeInsert) {
    var boxSizeInsert = parseInt(boxSize[firstVariant])
  }

  if (uomInsert === 'case') {
    if (caseSizeInsert === null | isNaN(caseSizeInsert) | caseSizeInsert === '1' | caseSizeInsert === 1) {
      if (packSizeDiv) {
        packSizeDiv.innerHTML = ''
      };
    } else {
      if (packSizeDiv) {
        packSizeDiv.innerHTML = ' of ' + caseSizeInsert
      }
    }
  } else if (uomInsert === 'each') {
    if (caseQtyDiv) {
      if (!isNaN(caseSizeInsert)) {
        if (caseSizeInsert !== 1) {
          caseQtyDiv.style.display = 'table-row'
          caseQtySpan.innerText = caseSizeInsert
        }
      } else {
        caseQtyDiv.style.display = 'none'
      }
    }
    if (boxQtyDiv) {
      if (!isNaN(boxSizeInsert)) {
        if (boxSizeInsert !== 1) {
          boxQtyDiv.style.display = 'table-row'
          boxQtySpan.innerHTML = boxSizeInsert
        }
      } else {
        boxQtyDiv.style.display = 'none'
      }
    }
  } else if (uomInsert === 'count') {
    if (boxSizeInsert === null | isNaN(boxSizeInsert) | boxSizeInsert === '1' | boxSizeInsert === 1) {
      if (packSizeDiv) {
        packSizeDiv.innerHTML = ''
      };
    } else {
      if (packSizeDiv) {
        uomDiv.innerHTML = boxSizeInsert + uomInsert
      }
    }
  } else {
    if (boxSizeInsert === null | isNaN(boxSizeInsert) | boxSizeInsert === '1' | boxSizeInsert === 1) {
      if (packSizeDiv) {
        packSizeDiv.innerHTML = ''
      };
    } else {
      if (packSizeDiv) {
        packSizeDiv.innerHTML = ' of ' + boxSizeInsert
      }
    };
    if (!isNaN(caseSizeInsert)) {
      if (caseSizeInsert !== 1) {
        if (caseQtyDiv) {
          caseQtyDiv.style.display = 'table-row'
          caseQtySpan.innerText = caseSizeInsert
        }
      }
    } else {
      if (caseQtyDiv) {
        caseQtyDiv.style.display = 'none'
      }
    }
  }
}

//sets inital productSize
var packSizeDiv = document.getElementById("productSize")
var productSize = localStorage.getItem("productSize")
productSize = JSON.parse(productSize)
if (packSizeDiv) {
  if (productSize) {
    var productSizeInsert = productSize[firstVariant]
    packSizeDiv.innerHTML = productSizeInsert
  } else {
    packSizeDiv.innerHTML = '-'
  }
}

//sets inital lowerPrice

var lowerPriceDiv = document.getElementById("lowerPrice")
var lowerPrice = localStorage.getItem("lowerPrice")
lowerPrice = JSON.parse(lowerPrice)

if (lowerPriceDiv && lowerPrice) {
  if (lowerPrice[firstVariant] === 'true') {
    lowerPriceDiv.style.display = ''
  }
}

//sets inital discontinued divs
var discontinuedDiv = document.getElementById("disc-unav")
var buyButtons = document.getElementsByClassName("product-form__payment-container")[0]
var discontinued = localStorage.getItem("discontinued")
discontinued = JSON.parse(discontinued)
if (discontinued[firstVariant] === true) {
  if (discontinuedDiv) {
    discontinuedDiv.style.display = 'block'
  }
  if (buyButtons) {
    buyButtons.style.display = 'none'
  }
}

//sets discontinued badge

var discontinuedSpan = document.getElementById("disc-badge")
var discontinued_meta = localStorage.getItem("discontinued_meta")
discontinued_meta = JSON.parse(discontinued_meta)
if (discontinued_meta) {
  if (discontinued_meta[firstVariant] === true) {
    console.log(discontinued_meta[firstVariant])
    if (discontinuedSpan) {
      discontinuedSpan.remove()
    }
    var element = document.createElement('span')
    element.classList.add('product-label')
    element.classList.add('product-label--on-sale')
    element.id = 'disc-badge'
    element.innerHTML = "Discontinued"
    if (document.getElementsByClassName("product-meta__label-list")[0]) {
      document.getElementsByClassName("product-meta__label-list")[0].appendChild(element)
    }
  }
}

document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  // Variant metafield maps are keyed by Shopify variant ID. Saving the
  // option handle here caused MOQ/increment lookups to return undefined until a
  // page reload reset currentID to the numeric variant ID.
  if (variant && variant.id) {
    localStorage.setItem("currentID", String(variant.id))
    setTimeout(function () {
      applyVariantQuantityRules(String(variant.id))
    }, 0)
  }
});

function getPositiveInteger(value, fallback) {
  var parsedValue = parseInt(value, 10)
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallback
}

function getVariantQuantityRules(variantID) {
  var moqMap
  var incrementMap

  try {
    moqMap = JSON.parse(localStorage.getItem("moq")) || {}
    incrementMap = JSON.parse(localStorage.getItem("order_increments")) || {}
  } catch (error) {
    moqMap = {}
    incrementMap = {}
  }

  return {
    moq: getPositiveInteger(moqMap[variantID], 1),
    increment: getPositiveInteger(incrementMap[variantID], 1)
  }
}

function applyVariantQuantityRules(variantID) {
  var quantitySelector = document.getElementById("quantity-selector")
  var moqInfoDiv = document.getElementById("moqInfoDiv")
  var moqQtySpan = document.getElementById("moqQtySpan")
  var rules = getVariantQuantityRules(variantID)

  if (quantitySelector) {
    quantitySelector.value = rules.moq
  }
  if (moqInfoDiv) {
    moqInfoDiv.style.display = rules.moq > 1 ? 'table-row' : 'none'
  }
  if (moqQtySpan) {
    moqQtySpan.innerHTML = rules.moq
  }
}

function customVariantChange(x, productUrl) {
  
  console.log(`passed value: ${x}`)
  setTimeout(() => {
    const locationHref = window.location.href; // full URL
    const url = new URL(locationHref);        // create URL object
    const variantParam = url.searchParams.get('variant'); // get the "variant" parameter
    console.log('Variant:', variantParam);

    let currentID;

    if(!variantParam){
      let mappings = localStorage.getItem('variant_id_map')
      if(!mappings){
        console.log(location.origin,productUrl)
        location.href = productUrl; // absolute URL
      }
      mappings = JSON.parse(mappings)
      const selected = Array.from(document.querySelectorAll('input:checked'));
      let v = ''
      for(const [index,select] of selected.entries()){
        v += select.value.toLowerCase()
        if(index + 1 !== selected.length) v += '-'
      }
      const key = v.trim().toLowerCase(); // assuming your keys are lowercase

      for(const map in mappings){
        console.log(`${key} is ${key === map ? 'INDEED' : 'NOT'} equal to ${map}`)
      }

      console.log(mappings,key,mappings[key])
      if(mappings[key]){
        currentID = mappings[key]
      } else {
        location.href = productUrl
      }
      console.log(localStorage.getItem('variant_id_map'))
      return
    } else {
      currentID = variantParam
    }

    currentID = currentID.replace('#','').replace('(','').replace(')','')
    //localStorage.setItem("currentID",currentID)
    //handles size change
    var packSizeDiv = document.getElementById("productSize")
    var productSize = localStorage.getItem("productSize")
    productSize = JSON.parse(productSize)
    console.log(productSize,packSizeDiv)

    if (productSize) {
      var productSizeInsert = productSize[currentID]
      if (packSizeDiv) {
        packSizeDiv.innerHTML = productSizeInsert
      }
    }

    //handles lower price change

    var lowerPrice = localStorage.getItem("lowerPrice")
    lowerPrice = JSON.parse(lowerPrice)

    console.log(currentID)

    if (document.getElementById("lowerPrice") && lowerPrice) {
      if (lowerPrice[currentID] === 'true') {
        document.getElementById("lowerPrice").style.display = ''
      }
    }

    //handles salon price change
    var metaData = localStorage.getItem("metaData")
    var metaDealData = localStorage.getItem("metaDealData")
    metaData = JSON.parse(metaData)
    metaDealData = JSON.parse(metaDealData)
    var salonPrice = (parseFloat(metaData[currentID]))
    if (isNaN(salonPrice)) {
      salonPrice = '$  -'
    } else {
      salonPrice = '$' + salonPrice.toFixed(2)
    }
    var salonDealPrice = (parseFloat(metaDealData[currentID]))
    if (isNaN(salonDealPrice)) {
      document.getElementById("salonPrice").innerHTML = salonPrice
      document.getElementById("highlight").classList.remove("price--highlight");
      document.getElementById("salonRegularPrice").innerHTML = ''
    } else {
      document.getElementById("salonPrice").innerHTML = '$' + salonDealPrice.toFixed(2)
      document.getElementById("highlight").classList.add("price--highlight");
      document.getElementById("salonRegularPrice").innerHTML = salonPrice
    };

    //handles uom and pack size change
    var uom = localStorage.getItem("uom")
    uom = JSON.parse(uom)
    var caseSize = localStorage.getItem("caseSize")
    var boxSize = localStorage.getItem("boxSize")
    caseSize = JSON.parse(caseSize)
    boxSize = JSON.parse(boxSize)
    if (caseSize) {
      var caseSizeInsert = parseInt(caseSize[currentID])
    }
    if (boxSize) {
      var boxSizeInsert = parseInt(boxSize[currentID])
    }
    console.log(uom)
    if (uom && uom[currentID]) {
      var uomInsert = uom[currentID]
    }
    if (!uomInsert) {
      document.getElementById("uomDiv").innerHTML = ''
    } else {
      document.getElementById("uomDiv").innerHTML = '  / ' + uomInsert
    };

    if (uomInsert === 'case') {
      if (caseSizeInsert === null | isNaN(caseSizeInsert) | caseSizeInsert === '1' | caseSizeInsert === 1) {
        if (document.getElementById("packSizeDiv")) {
          document.getElementById("packSizeDiv").innerHTML = ''
        };
      } else {
        if (document.getElementById("packSizeDiv")) {
          document.getElementById("packSizeDiv").innerHTML = ' of ' + caseSizeInsert
        }
      }
    } else if (uomInsert === 'each') {
      if (document.getElementById("caseQtyDiv")) {
        if (!isNaN(caseSizeInsert)) {
          if (caseSizeInsert !== 1) {
            document.getElementById("caseQtyDiv").style.display = 'table-row'
            document.getElementById("caseQtySpan").innerHTML = caseSizeInsert
          }
        } else {
          document.getElementById("caseQtyDiv").style.display = 'none'
        }
      }
      if (document.getElementById("boxQtyDiv")) {
        if (!isNaN(boxSizeInsert)) {
          if (boxSizeInsert !== 1) {
            boxQtyDiv.style.display = 'table-row'
            document.getElementById("boxQtySpan").innerHTML = boxSizeInsert
          }
        } else {
          document.getElementById("boxQtyDiv").style.display = 'none'
        }
      }
    } else if (uomInsert === 'count') {
      if (boxSizeInsert === null | isNaN(boxSizeInsert) | boxSizeInsert === '1' | boxSizeInsert === 1) {
        if (document.getElementById("packSizeDiv")) {
          document.getElementById("packSizeDiv").innerHTML = ''
        };
      } else {
        if (document.getElementById("packSizeDiv")) {
          document.getElementById("uomDiv").innerHTML = boxSizeInsert + uomInsert
        }
      }
    } else {
      if (boxSizeInsert === null | isNaN(boxSizeInsert) | boxSizeInsert === '1' | boxSizeInsert === 1) {
        if (document.getElementById("packSizeDiv")) {
          document.getElementById("packSizeDiv").innerHTML = ''
        };
      } else {
        if (document.getElementById("packSizeDiv")) {
          document.getElementById("packSizeDiv").innerHTML = ' of ' + boxSizeInsert
        }
      };
      if (!isNaN(caseSizeInsert)) {
        if (caseSizeInsert !== 1) {
          document.getElementById("caseQtyDiv").style.display = 'table-row'
          document.getElementById("caseQtySpan").innerHTML = caseSizeInsert
        }
      } else {
        document.getElementById("caseQtyDiv").style.display = 'none'
      }
    }

    //handles discontinued div changes
    var discontinued = localStorage.getItem("discontinued")
    discontinued = JSON.parse(discontinued)
    if (discontinued[currentID] === true) {
      if (document.getElementById("disc-unav")) {
        document.getElementById("disc-unav").style.display = 'block'
      }
      if (document.getElementsByClassName("product-form__payment-container")[0]) {
        document.getElementsByClassName("product-form__payment-container")[0].style.display = 'none'
      }
    } else {
      if (document.getElementById("disc-unav")) {
        document.getElementById("disc-unav").style.display = 'none'
      }
      if (document.getElementsByClassName("product-form__payment-container")[0]) {
        document.getElementsByClassName("product-form__payment-container")[0].style.display = 'flex'
      }
    }

    //handles discontinueed badge change 
    var discontinued_meta = localStorage.getItem("discontinued_meta")
    discontinued_meta = JSON.parse(discontinued_meta)
    if (discontinued_meta) {
      if (discontinued_meta[currentID] === true) {
        if (document.getElementById('disc-badge')) {
          document.getElementById('disc-badge').remove()
        }
        var element = document.createElement('span')
        element.classList.add('product-label')
        element.classList.add('product-label--on-sale')
        element.id = 'disc-badge'
        element.innerHTML = "Discontinued"
        document.getElementsByClassName("product-meta__label-list")[0].appendChild(element)
      }
    }

    //sets quantity selector moq 
    applyVariantQuantityRules(currentID)
  }, 50);

};




function modalVariantChange(x, y, z, j, k, l, i, p, q, t) {

  var firstVariant = z

  var disc = '{"' + String(i).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  disc = disc.replaceAll('"false"', 'false')
  disc = disc.replaceAll('"true"', 'true')
  disc = JSON.parse(disc)

  var discBadge = '{"' + String(p).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  discBadge = discBadge.replaceAll('"false"', 'false')
  discBadge = discBadge.replaceAll('"true"', 'true')
  discBadge = JSON.parse(discBadge)


  var moq = '{"' + String(q).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  moq = JSON.parse(moq)

  var increments = '{"' + String(t).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  increments = JSON.parse(increments)

  //sets inistal size
  var productSize = '{"' + String(l).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  productSize = JSON.parse(productSize)

  if (productSize) {
    var productSizeInsert = productSize[firstVariant]
    if (document.getElementById("productSize")) {
      document.getElementById("productSize").innerHTML = productSizeInsert
    }
  }

  //sets inital salon price
  var metaData = '{"' + String(x).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  metaData = JSON.parse(metaData)
  var metaDealData = '{"' + String(y).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  metaDealData = JSON.parse(metaDealData)
  var salonPrice = (parseFloat(metaData[firstVariant]))
  if (isNaN(salonPrice)) {
    salonPrice = '$  -'
  } else {
    salonPrice = '$' + salonPrice.toFixed(2)
  }
  var salonDealPrice = (parseFloat(metaDealData[firstVariant]))
  localStorage.setItem("productSize", JSON.stringify(productSize))
  localStorage.setItem("discontinued", JSON.stringify(disc))
  localStorage.setItem("discontinued-meta", JSON.stringify(discBadge))
  localStorage.setItem("moq", JSON.stringify(moq))
  localStorage.setItem("order_increments", JSON.stringify(increments))
  localStorage.setItem("metaData", JSON.stringify(metaData))
  localStorage.setItem("metaDealData", JSON.stringify(metaDealData))
  localStorage.setItem("firstVariant", firstVariant)
  localStorage.setItem("currentID", firstVariant)
  if (isNaN(salonDealPrice)) {
    document.getElementById("salonPrice").innerHTML = salonPrice
    document.getElementById("salonPriceLoader").style.display = 'none'
  } else {
    document.getElementById("salonPrice").innerHTML = '$' + salonDealPrice.toFixed(2)
    document.getElementById("salonPriceLoader").style.display = 'none'
    document.getElementById("highlight").classList.add("price--highlight");
    document.getElementById("salonRegularPrice").innerHTML = salonPrice
  };

  //sets inital uom and pack size
  var uom = '{"' + String(j).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  uom = JSON.parse(uom)
  localStorage.setItem("uom", JSON.stringify(uom))
  var packSize = '{"' + String(k).replaceAll(',', '","').replaceAll(': ', '":"') + '"}'
  packSize = JSON.parse(packSize)
  localStorage.setItem("packSize", JSON.stringify(packSize))
  var uomInsert = uom[firstVariant]
  var packSizeInsert = parseInt(packSize[firstVariant])
  var caseSize = localStorage.getItem("caseSize")
  var boxSize = localStorage.getItem("boxSize")
  caseSize = JSON.parse(caseSize)
  boxSize = JSON.parse(boxSize)
  var caseSizeInsert = parseInt(caseSize[firstVariant])
  var boxSizeInsert = parseInt(boxSize[firstVariant])
  if (uomInsert === null) {
    document.getElementById("uomDiv").innerHTML = ''
  } else {
    document.getElementById("uomDiv").innerHTML = '  / ' + uomInsert
  };

  if (uomInsert === 'case') {
    if (caseSizeInsert === null | isNaN(caseSizeInsert) | caseSizeInsert === '1' | caseSizeInsert === 1) {
      if (document.getElementById("packSizeDiv")) {
        document.getElementById("packSizeDiv").innerHTML = ''
      };
    } else {
      if (document.getElementById("packSizeDiv")) {
        document.getElementById("packSizeDiv").innerHTML = ' of ' + caseSizeInsert
      }
    }
  } else if (uomInsert === 'each') {
    if (document.getElementById("caseQtyDiv")) {
      if (!isNaN(caseSizeInsert)) {
        if (caseSizeInsert !== 1) {
          document.getElementById("caseQtyDiv").style.display = 'table-row'
          document.getElementById("caseQtySpan").innerHTML = caseSizeInsert
        }
      } else {
        document.getElementById("caseQtyDiv").style.display = 'none'
      }
    }
    if (document.getElementById("boxQtyDiv")) {
      if (!isNaN(boxSizeInsert)) {
        if (boxSizeInsert !== 1) {
          boxQtyDiv.style.display = 'table-row'
          document.getElementById("boxQtySpan").innerHTML = boxSizeInsert
        }
      } else {
        document.getElementById("boxQtyDiv").style.display = 'none'
      }
    }
  } else if (uomInsert === 'count') {
    if (boxSizeInsert === null | isNaN(boxSizeInsert) | boxSizeInsert === '1' | boxSizeInsert === 1) {
      if (document.getElementById("packSizeDiv")) {
        document.getElementById("packSizeDiv").innerHTML = ''
      };
    } else {
      if (document.getElementById("packSizeDiv")) {
        document.getElementById("uomDiv").innerHTML = boxSizeInsert + uomInsert
      }
    }
  } else {
    if (boxSizeInsert === null | isNaN(boxSizeInsert) | boxSizeInsert === '1' | boxSizeInsert === 1) {
      if (document.getElementById("packSizeDiv")) {
        document.getElementById("packSizeDiv").innerHTML = ''
      };
    } else {
      if (document.getElementById("packSizeDiv")) {
        document.getElementById("packSizeDiv").innerHTML = ' of ' + boxSizeInsert
      }
    };
    if (!isNaN(caseSizeInsert)) {
      if (caseSizeInsert !== 1) {
        document.getElementById("caseQtyDiv").style.display = 'table-row'
        document.getElementById("caseQtySpan").innerHTML = caseSizeInsert
      }
    } else {
      document.getElementById("caseQtyDiv").style.display = 'none'
    }
  }

  //handles discontinued div change
  var discontinued = localStorage.getItem("discontinued")
  discontinued = JSON.parse(discontinued)
  var discontinuedCheck = discontinued[firstVariant];
  if (discontinuedCheck === true) {
    if (document.getElementById("disc-unav")) {
      document.getElementById("disc-unav").style.display = 'block'
    }
    if (document.getElementsByClassName("product-form__payment-container")[0]) {
      document.getElementsByClassName("product-form__payment-container")[0].style.display = 'none'
    }
  } else {
    if (document.getElementById("disc-unav")) {
      document.getElementById("disc-unav").style.display = 'none'
    }
    if (document.getElementsByClassName("product-form__payment-container")[0]) {
      document.getElementsByClassName("product-form__payment-container")[0].style.display = 'block'
    }
  }

  //handles discontinued badge change
  var disc_Badge = localStorage.getItem("discontinued-meta")
  disc_Badge = JSON.parse(disc_Badge)
  if (discontinuedCheck === true) {
    if (document.getElementById('disc-badge')) {
      document.getElementById('disc-badge').remove()
    }
    var element = document.createElement('span')
    element.classList.add('product-label')
    element.classList.add('product-label--on-sale')
    element.id = 'disc-badge'
    element.innerHTML = "Discontinued"
    document.getElementsByClassName("product-meta__label-list")[0].appendChild(element)
  }
  if (document.getElementById("salonPriceLoader").style.display !== 'none') {
    modalVariantChange(x, y, z, j, k, l)
  }
}

function hideDiv(x) {
  document.getElementById(x).style.display = 'none'
}


function updateItems(x, y, z, a, b) {
  var itemID = x
  var adjustType = y
  var quantity = z
  var button = a
  var specialQTY = b
  var cartItems = localStorage.getItem('cartItems')
  cartItems = JSON.parse(cartItems)
  if (adjustType === 'change') {
    cartItems[itemID]['Item Details']['quantity'] = quantity
  } else if (adjustType === 'increase') {
    if (specialQTY) {
      var newQuantity = specialQTY
      newQuantity = parseInt(newQuantity)
    } else {
      var newQuantity = button.previousElementSibling.value
      newQuantity = parseInt(newQuantity) + 1
    }
    cartItems[itemID]['Item Details']['quantity'] = newQuantity
  } else if (adjustType === 'remove') {
    delete cartItems[itemID];
  } else {
    if (specialQTY) {
      var newQuantity = specialQTY
      newQuantity = parseInt(newQuantity)
    } else {
      var newQuantity = button.nextElementSibling.value
      newQuantity = parseInt(newQuantity) - 1
    }
    cartItems[itemID]['Item Details']['quantity'] = newQuantity
  }
  localStorage.setItem('cartItems', JSON.stringify(cartItems))

}


function moqChange(x, y) {
  var currentID = localStorage.getItem("currentID")
  if (!currentID) return
  currentID = currentID.replace('#','').replace('(','').replace(')','')
  var quantitySelectorMinus = document.getElementById("quantity-selector-minus")
  var quantitySelectorInput = document.getElementById("quantity-selector")
  if (!quantitySelectorInput) return

  var rules = getVariantQuantityRules(currentID)
  var moq = rules.moq
  var orderIncrements = rules.increment
  var inputValue = getPositiveInteger(quantitySelectorInput.value, moq)

  if (x === 'increase') {
    if (quantitySelectorMinus && inputValue >= moq) {
      quantitySelectorMinus.disabled = false
    }
    quantitySelectorInput.value = inputValue + orderIncrements - 1
  } else if (x === 'decrease') {
    if (inputValue <= moq) {
      if (quantitySelectorMinus) quantitySelectorMinus.disabled = true
      quantitySelectorInput.value = moq
    } else {
      quantitySelectorInput.value = Math.max(moq, inputValue - orderIncrements + 1)
    }
  } else if (x === 'selector') {
    var enteredValue = getPositiveInteger(y, moq)
    if (enteredValue <= moq) {
      quantitySelectorInput.value = moq
    } else {
      var divid = enteredValue / orderIncrements
      var isFloat = Number(divid) === divid && divid % 1 !== 0
      quantitySelectorInput.value = isFloat ? Math.round(divid) * orderIncrements : enteredValue
    }
  }
}

function moqCartChange(x, y, z, i) {
  var quantitySelectorMinus = document.getElementById(`quantity-selector-minus-${i}`)
  var quantitySelectorInput = document.getElementById(`quantity-selector-${i}`)
  var quantitySelectorPlus = document.getElementById(`quantity-selector-plus-${i}`)
  var moq = z
  if (moq) {
    var inputValue = parseInt(quantitySelectorInput.value)
    if (x === 'increase') {
      if (inputValue >= moq) {
        quantitySelectorMinus.disabled = false
        console.log('null')
      }
      quantitySelectorInput.value = inputValue + moq - 1
    } else if (x === 'decrease') {
      if (inputValue <= moq) {
        quantitySelectorMinus.disabled = 'true'
      } else {
        quantitySelectorInput.value = inputValue - moq + 1
      }
    } else if (x === 'selector') {
      if (y <= moq) {
        quantitySelectorInput.value = moq
      } else {
        var divid = parseInt(y) / moq
        var isFloat = Number(divid) === divid && divid % 1 !== 0
        if (isFloat === true) {
          quantitySelectorInput.value = (Math.round(divid) * moq)
        }
      }
    }
  }
}

function orderCase(x) {
  var selector = document.getElementById("quantity-selector")
  var qty = parseInt(document.getElementById(x).innerHTML)
  console.log(qty)
  selector.value = qty
}
